export default __webpack_public_path__ + "static/media/wrong.01b654ed.mp3";